import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { DvmpService } from 'src/app/shared/services/dvmp.service';
import { LocalStorageService } from 'src/app/shared/services/localStorage.service';
import { GlobalvaribleService } from 'src/app/services/globalvarible.service';
import * as momenttz from 'moment-timezone';

import * as $ from 'jquery';


@Component({
  selector: 'app-dvmp',
  templateUrl: './treatmentcycles.html',
  styleUrls: ['./treatmentcycles.css']
})
export class DvmpComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() patientdata: any;
  @Input() treatmentcomponnetindex: any;
  indexparent: any;
  dvmp_treatmentlabel: JSON;
  original_treatment: any;
  enable = false;
  numberOfcycles: number;
  @Output() defaultvalue: any[] = [];
  dfValue = new EventEmitter();
  treatmentmodel: any[];
  crcycle: number;
  localArray: any;
  checked = false;
  disclaimer = false;
  flagdefaulvalue = true;
  defaultfirsttimevalue: any;
  reversedropdownselection = false;
  flagshow = false;
  message: String;
  checkflag: true;
  optiontag = true;
  defaultOptionTag = false;
  emptyvalue;
  checkTreatment;
  selectedTreatment: string;
  FirstDefaultvalues: any;
  FirstChange: Boolean;
  @Output() changeEvt = new EventEmitter<any>();
  emitedObject: Object = {
    'reversedropdownselection': false,
    'checkflag': false
  };
  constructor(public _dvmp: DvmpService, public _localstorage: LocalStorageService, public _globalvarible: GlobalvaribleService) {

  }

  ngOnChanges(changes: SimpleChanges) {
    this._dvmp.ClearErrorDisclimer();
    this.selectedTreatment = this.patientdata.data.Tratamientos;
    for (const propName in changes) {
      if (propName === 'patientdata' && !changes[propName].firstChange) {
        this.crcycle = this.patientdata.currentCycle;
        this.dvmp_treatmentlabel = this.original_treatment.filter((res) => {
          if (res.type === this.patientdata.data.Tratamientos) {

            this.emptyvalue = parseInt(res.emptyOptionRange, 10);
            return res;
          }
        });
        this.dvmp_treatmentlabel = this.dvmp_treatmentlabel[0].options;
      }

    }
    this.SetDefaultvalue();


    this.FirstDefaultvalues = JSON.parse(localStorage.getItem('DeafultValues'));
  }
  ngAfterViewInit() {

    setTimeout(() => {
      const DropdownList = (document.getElementById('checboxCheck')) as HTMLSelectElement;
      DropdownList['checked'] = false;
    }, 1000);
  }
  ngOnInit() {
    this.indexparent = this.treatmentcomponnetindex;
    this.crcycle = this.patientdata.currentCycle;
    this._dvmp.getDvmp(this._dvmp.locale_code).subscribe(res => {
      this.original_treatment = res.treatments;
      this.dvmp_treatmentlabel = res.treatments.filter((response) => {
        if (response.type === this.patientdata.data.Tratamientos) {

          this.emptyvalue = parseInt(response.emptyOptionRange, 10);
          return response;
        }
      });
      this.dvmp_treatmentlabel = this.dvmp_treatmentlabel[0].options;
      const dvar = res.treatments.filter((resp) => {
        if (resp.type === this.patientdata.data.Tratamientos) {
          this._dvmp.treatsArray = resp.options.map(item => ({ 'value': item.label.replace('(days)', '').trim() }));
        }
      });
      this._dvmp.colors = res.colors;
      this._dvmp.drugs = res.drugs;
      // console.log(this._dvmp.colors)
      this.enable = true;
      this.SetDefaultvalue();
    });
  }


  defCahange(i, newval, defval) {
    if (this.crcycle === 1) {
      this.FirstChange = true;
    } else {
      this.FirstChange = false;
    }
    const arry = [];
    for (let index = 0; index < defval.length; index++) {
      const selectids = 'Slectbar' + this.crcycle + index;
      const selectedIndedval = $('#' + selectids + ' option:selected').val();
      arry.push(selectedIndedval);
    }
    this._dvmp.Checkdefaultvalue(this.crcycle, arry, this.FirstDefaultvalues);
    this.checked = true;
    this.disclaimer = true;
    function compare(a, b) {
      if (a.cycle < b.cycle) {
        return -1;
      }
      if (a.cycle > b.cycle) {
        return 1;
      }
      return 0;
    }

    if (this.flagdefaulvalue) {
      this.defaultfirsttimevalue = JSON.parse(this._localstorage.getItem('DeafultValues'));
      this.defaultfirsttimevalue = this.defaultfirsttimevalue.sort(compare);
      this.flagdefaulvalue = false;
    }
    let defaultcycle;
    for (let k = 0; k < this.defaultfirsttimevalue.length; k++) {
      if (this.defaultfirsttimevalue[k].cycle === this.crcycle) {
        defaultcycle = this.defaultfirsttimevalue[k];
      }
    }
    this.reversedropdownselection = defaultcycle.default[i] === newval.target.value;
    this._globalvarible.setdropdownflag(this.checked, this.reversedropdownselection);
    this.emitedObject['reversedropdownselection'] = this.reversedropdownselection;
    this.emitedObject['checkflag'] = this.checked;
    this.changeEvt.emit(this.emitedObject);
    const crc = {
      'cycle': this.crcycle,
      'default': this.defaultvalue
    };
    let localValues = JSON.parse(this._localstorage.getItem('DeafultValues'));

    localValues = localValues.filter((res) => res.cycle !== this.crcycle);
    localValues.push(crc);
    this._localstorage.setItem('DeafultValues', JSON.stringify(localValues));
  }

  splitDoseSelected(event, item) {





    const selectvalue = document.getElementsByClassName('form-control cycles');
    const defaultvalue = JSON.parse(localStorage.getItem('DeafultValues'));
    const DropdownList = (selectvalue[0]) as HTMLSelectElement;
    const SelectedIndex = DropdownList.selectedIndex;



    if (event) {
      DropdownList.selectedIndex = 3;
      defaultvalue[0].default[0] = ' 1*, 2*, 8, 15, 22, 29, 36 (ciclo 42 días)';
      this._localstorage.setItem('DoseDivide', event);

      this._dvmp.getDvmp(this._dvmp.locale_code).subscribe((data) => {
        const dividdata = data.filter((itm) => itm.type === this.selectedTreatment);
        this._dvmp.setDoseDividaDefaults(dividdata[0].DoseDivida);
      });
      const pateintDet = JSON.parse(localStorage.getItem('patientdetails'));
      const startdate = new Date(pateintDet.Fechaactual);
      this._localstorage.setItem('TreatmentStartDate', startdate);
      if (startdate.getDay() === 5) {
        /******block of drugs skipped for weekends and moved to monday */
        /*let updatedStartDate = new Date(momenttz(startdate,"YYYY-MM-DD",true).add(3, "days"));
        pateintDet.Fechaactual = updatedStartDate.toISOString();
        this._localstorage.setItem("patientdetails", JSON.stringify(pateintDet));
        this._localstorage.setItem("startDateChanged", true);*/
        /******ends block of drugs*****/
      }
    } else {
      DropdownList.selectedIndex = 0;
      defaultvalue[0].default[0] = '1, 8, 15, 22 (ciclo 28 días)';
      const DoseDivide = JSON.parse(this._localstorage.getItem('DoseDivide'));
      if (DoseDivide) {
        this._localstorage.removeItem('DoseDivide');
      }


    }
    localStorage.removeItem('DeafultValues');
    localStorage.setItem('DeafultValues', JSON.stringify(defaultvalue));

  }

  SetDefaultvalue() {

    this.defaultvalue = [];
    for (const data in this.dvmp_treatmentlabel) {
      for (const datax in this.dvmp_treatmentlabel[data].default) {
        if (this.dvmp_treatmentlabel[data].default[datax].cycle.indexOf(this.patientdata.currentCycle) > -1) {
          this.defaultvalue.push(this.dvmp_treatmentlabel[data].default[datax].preselect);
        }

        switch (this.patientdata.data.Tratamientos) {
          case 'DVmp':
            if (this.patientdata.currentCycle > 10) {
              if (this.dvmp_treatmentlabel[data].default[datax].cycle.indexOf(10) > -1) {
                this.defaultvalue.push(this.dvmp_treatmentlabel[data].default[datax].preselect);
              }
            }
            break;
          case 'DVd':
            if (this.patientdata.currentCycle > 9) {
              if (this.dvmp_treatmentlabel[data].default[datax].cycle.indexOf(9) > -1) {
                this.defaultvalue.push(this.dvmp_treatmentlabel[data].default[datax].preselect);
              }
            } break;
          case 'DRd':
            if (this.patientdata.currentCycle > 7) {
              if (this.dvmp_treatmentlabel[data].default[datax].cycle.indexOf(7) > -1) {
                this.defaultvalue.push(this.dvmp_treatmentlabel[data].default[datax].preselect);
              }
            }
            break;
          case 'D':
            if (this.patientdata.currentCycle > 7) {
              if (this.dvmp_treatmentlabel[data].default[datax].cycle.indexOf(7) > -1) {
                this.defaultvalue.push(this.dvmp_treatmentlabel[data].default[datax].preselect);
              }
            }
            break;
          default:
            break;
        }

      }


    }

    if (this.crcycle !== undefined) {
      const localValues = this._localstorage.getItem('DeafultValues');
      if (localValues == null) {
        this._localstorage.removeItem('DeafultValues');
        this.localArray = {
          'cycle': this.crcycle,
          'default': this.defaultvalue
        };
        const lArray = [this.localArray];
        this._localstorage.setItem('DeafultValues', JSON.stringify(lArray));
      } else {
        const lValues = JSON.parse(localValues);
        this.localArray = {

          'cycle': this.crcycle,
          'default': this.defaultvalue
        };
        lValues.push(this.localArray);
        this._localstorage.setItem('DeafultValues', JSON.stringify(lValues));
      }
      this.FirstDefaultvalues = JSON.parse(this._localstorage.getItem('DeafultValues'));

    }



  }
}
